import React, { lazy, Suspense } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import withAdminLayout from '../../layout/withAdminLayout';
import { Spin } from 'antd';

const Dashboard       = lazy(() => import('../../container/qr/Index'));
const PaymentHistory = lazy(() => import('../../container/qr/PaymentHistory'));

function QRRoutes() {
    return (
        <Suspense
            fallback={
                <div className="spin">
                    <Spin />
                </div>  
            }
        >
            <Routes>
                <Route path="dashboard" element={<Dashboard />} />
                <Route path="qr_payment_history" element={<PaymentHistory />} />
                <Route path="*" element={<Navigate to="/dashboard" />} />
            </Routes>
        </Suspense>
    );
}

export default withAdminLayout(QRRoutes);
